import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { AppService } from "src/app/app.service";
import { Global } from "src/global";

@Injectable({
  providedIn: "root",
})
export class TutorialVidsService {
  constructor(public globals: Global, private appservice: AppService) {}
}
